import { render, staticRenderFns } from "./u-table-column.vue?vue&type=template&id=8ef6f1ec&"
import script from "./u-table-column.vue?vue&type=script&lang=js&"
export * from "./u-table-column.vue?vue&type=script&lang=js&"
import style0 from "./u-table-column.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports